(() => {
  const POP = "rz-pop";

  function pop(el){
    if(!el) return;
    el.classList.remove(POP);
    // reflow para reiniciar animación
    void el.offsetWidth;
    el.classList.add(POP);
  }

  function onVariantChange(target){
    // Swatches: input dentro de .color-swatch
    const sw = target.closest?.('.color-swatch');
    if (sw) { pop(sw); return; }

    // Pills: label[for=id]
    const id = target.id;
    if (id) {
      const lbl = document.querySelector(`label[for="${CSS.escape(id)}"]`);
      if (lbl) { pop(lbl); return; }
    }
  }

  function bindDelegated(){
    // Delegación: funciona aunque Shrine re-renderice
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || t.type !== 'radio') return;
      onVariantChange(t);
    }, true);

    // Backup: algunos themes “cambian” por click al label
    document.addEventListener('click', (e) => {
      const lbl = e.target.closest?.('label');
      if (!lbl) return;
      const forId = lbl.getAttribute('for');
      if (!forId) return;
      const input = document.getElementById(forId);
      if (input && input.type === 'radio') {
        // da chance a que cambie el checked
        setTimeout(() => onVariantChange(input), 0);
      }
    }, true);
  }

  function observeRenders(){
    // Por si Shrine reconstruye el nodo del picker, no pasa nada:
    // la delegación ya cubre. Pero esto ayuda a “pop” inicial al cargar.
    const mo = new MutationObserver(() => {
      // si existe una selección activa, haz pop suave al render
      const checked = document.querySelector('.color-swatch input[type="radio"]:checked, input[type="radio"]:checked');
      if (checked) onVariantChange(checked);
    });

    mo.observe(document.documentElement, { childList:true, subtree:true });
  }

  function boot(){
    bindDelegated();
    observeRenders();

    // Pop inicial si ya hay variante seleccionada
    const checked = document.querySelector('.color-swatch input[type="radio"]:checked, input[type="radio"]:checked');
    if (checked) onVariantChange(checked);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();

